<ng-select
  [items]="allimageFits"
  [clearable]="false"
  bindLabel="title"
  bindValue="value"
  [formControl]="imageFit"
  placeholder=""
></ng-select>
